import NavbarStyles from "./Navbar.module.scss";
import MayoIrisWhiteSvg from "../../assets/images/mayo_iris_white_logo.svg";
import ProfileButton from "../ProfileButton/ProfileButton";
import { useAppSelector } from "../../hooks/store";
import { ProfileData } from "../../common/common.model";
import { useEffect, useState } from "react";
import { getProjectMappings } from "../../services/auth.service";
import LumaHeaderSvg from "../../assets/images/luma_header_logo.svg";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../common/constants";

const Navbar = () => {
  const [projectName, setProjectName] = useState("");
  const profileData = useAppSelector(
    (store) => store?.rootReducer?.userInfoReducer?.profileData?.data
  );
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate(ROUTES.dashboard);
  }

  useEffect(() => {
    const fetchProjectName = async () => {
      try {
        const response = await getProjectMappings();
        if (
          response &&
          response.project_names &&
          response.project_names.length > 0
        ) {
          setProjectName(response.project_names[0]);
        }
      } catch (error) {
        console.error("Error fetching project name:", error);
      }
    };

    fetchProjectName();
  }, []);

  return (
    <div className={NavbarStyles.navContainer}>
      {projectName === "Mayo" ? (
        <img src={MayoIrisWhiteSvg} alt="" onClick={handleLogoClick} style={{cursor: "pointer"}} />
      ) : (
        <img src={LumaHeaderSvg} alt="" onClick={handleLogoClick} style={{cursor: "pointer"}} />
      )}
      <ProfileButton profileData={profileData as ProfileData} />
    </div>
  );
};

export default Navbar;
